// extracted by mini-css-extract-plugin
export default {"container":"CreateBlog_container_UB2RC","bottomBlock":"CreateBlog_bottomBlock_lvCWK","deleteBtn":"CreateBlog_deleteBtn_J8uhI","tabs":"CreateBlog_tabs_FIhTa"};